import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home"; // Example: Home Page
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={ <Home /> } />
      <Route path="/share" element={ <Home /> } />
      <Route path="*" element={ <NotFound /> } />
    </Routes>
  );
}
